const MuiMenu = {
  defaultProps: {
    elevation: 7,
  },
};

export default MuiMenu;
